<template>
  <div class="articles-pager">
    <div class="articles-pager__list">
      <div
        class="articles-pager__left"
        @click="decrement"
        :style="{visibility: currentPage === 1 ? 'hidden' : 'visible' }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40.414"
          height="40.414"
          viewBox="0 0 40.414 40.414"
        >
          <path
            class="articles-pager__left-icon"
            data-name="Path 147"
            d="M578.577,505.072v7.505H550V484h7.505v21.072Z"
            transform="translate(-26.462 -731.149) rotate(45)"
          />
        </svg>
      </div>

      <div class="articles-pager__items">
        <div
          :class="{'articles-pager__item': true, 'active': page === currentPage }"
          v-for="(page, index) in pages"
          :key="`${index}-page`"
          @click="() => numberClick(page)"
        >{{ page }}</div>
      </div>

      <div
        class="articles-pager__right"
        @click="increment"
        :style="{visibility: currentPage === pageCount ? 'hidden' : 'visible' }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40.414"
          height="40.414"
          viewBox="0 0 40.414 40.414"
        >
          <path
            class="articles-pager__right-icon"
            data-name="Path 148"
            d="M578.577,505.072v7.505H550V484h7.505v21.072Z"
            transform="translate(66.876 771.563) rotate(-135)"
          />
        </svg>
      </div>
    </div>

    <!-- <div
      class="articles-pager__btn btn"
      @click="increment"
      :style="{visibility: currentPage === pageCount ? 'hidden' : 'visible' }"
    >{{ nextPageCaption }}</div> -->
  </div>
</template>
<script>
export default {
  name: "Pagination",
  data: function() {
    return {
      currentPage: 1,
      scrollOffset: 0
    };
  },
  computed: {
    pages: function() {
      if (
        this.pageCount > 5 &&
        this.currentPage - 3 > 0 &&
        this.currentPage + 2 < this.pageCount
      ) {
        const result = [1, "..."];

        for (let i = this.currentPage - 3; i < this.currentPage + 2; i++)
          result.push(i + 1);

        result.push("...");
        result.push(this.pageCount);
        return result;
      }

      if (this.currentPage < 5 && !this.pageCount > 5) {
        const result = [];
        for (let i = 0; i < 5; i++) result.push(i + 1);
        if (this.pageCount > 5) {
          result.push("...");
          result.push(this.pageCount);
        }

        return result;
      }

      if (this.pageCount - this.currentPage < 5 && !this.pageCount > 5) {
        const result = [1, "..."];
        for (let i = this.pageCount - 5; i < this.pageCount; i++)
          result.push(i + 1);

        return result;
      }

      return Array.from(Array(this.pageCount).keys()).map(num => num + 1);
    }
  },

  methods: {
    resolveScrollOffset: function() {
      return document.documentElement.scrollHeight - window.scrollY;
    },
    remainInPosition: function(offset) {
      setTimeout(
        () =>
          window.scrollTo(0, document.documentElement.scrollHeight - offset),
        0
      );
    },
    increment: function() {
      if (this.currentPage + 1 <= this.pageCount) {
        const offset = this.resolveScrollOffset();
        this.currentPage += 1;
        this.$emit("change", this.currentPage);
        this.remainInPosition(offset);
      }
    },
    decrement: function() {
      if (this.currentPage - 1 > 0) {
        const offset = this.resolveScrollOffset();
        this.currentPage -= 1;
        this.$emit("change", this.currentPage);
        this.remainInPosition(offset);
      }
    },
    numberClick: function(page) {
      const offset = this.resolveScrollOffset();
      this.$emit("change", page);
      this.currentPage = page;

      this.remainInPosition(offset);
    }
  },

  props: {
    pageCount: {
      type: Number,
      required: true
    },
    nextPageCaption: {
      type: String,
      required: true
    }
  }
};
</script>